<template>
  <div>
    <v-container>
      <v-row v-for="(info, i) in numberinfo" :key="i">
        <v-col cols="4" class="pa-0"
          ><v-card
            height="100"
            outlined
            tile
            class="d-flex justify-center align-center text-center px-6"
          >
            ค่าคำตอบน้อยที่สุด <br />
            {{ info.min }}</v-card
          ></v-col
        >
        <v-col cols="4" class="pa-0"
          ><v-card
            height="100"
            outlined
            tile
            class="d-flex justify-center align-center text-center px-6"
          >
            ค่าคำตอบมากที่สุด <br />
            {{ info.max }}
          </v-card></v-col
        >
        <v-col cols="4" class="pa-0"
          ><v-card
            height="100"
            outlined
            tile
            class="d-flex justify-center align-center text-center px-6"
          >
            ค่าคำตอบเฉลี่ย <br />
            {{ parseFloat(info.average).toFixed(2) }}</v-card
          ></v-col
        >
      </v-row>
    </v-container>
    <br />
    <br />
    <v-card>
      <v-card-title primary-title
        ><v-spacer></v-spacer
        ><v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#033666" class="mx-2" dark v-bind="attrs" v-on="on">
              <span style="font-size: 12px">Social</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in social"
              :key="index"
              @click="
                PieChart(item.value, daterange),
                  NumberInfo(item.value, daterange)
              "
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#033666" class="mx-2" dark v-bind="attrs" v-on="on">
              <span style="font-size: 12px"> Chart</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in chart"
              :key="index"
              @click="ChartChange(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="letter-spacing: 0; width: 100%">
        <Pie
          :title="question.questionLabel"
          :data="pie"
          v-if="chart_selected === 'pie'"
        />
        <SingleBarChart
          :title="question.questionLabel"
          :data="pie"
          v-else-if="chart_selected === 'column'"
        />
        <BoxPlot v-else :data="boxplot" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Pie from "../Chart/Pie";
import BoxPlot from "../Chart/BoxPlot";
import SingleBarChart from "../Chart/SingleBarChart.vue";
import Swal from "sweetalert2";
export default {
  components: { BoxPlot, Pie, SingleBarChart },
  props: ["question", "daterange", "modal"],
  watch: {
    daterange(newValue) {
      if (!this.modal) {
        this.PieChart(this.social_selected, newValue);
        this.NumberInfo(this.social_selected, newValue);
      }
    },
  },
  data() {
    return {
      chart_selected: "pie",
      social_selected: "ALL",
      social: [
        { title: "All", value: "ALL" },
        { title: "Facebook", value: "FACEBOOK" },
        { title: "Line", value: "LINE" },
        { title: "OneChat", value: "ONECHAT" },
        { title: "Webform", value: "webform" },
      ],
      chart: [
        { title: "Pie Chart", value: "pie" },
        { title: "Bar Chart", value: "column" },
        // { title: "Box plot", value: "boxplot" },
      ],
      numberinfo: [],
      pie: {
        pointFormat: "{point.name}: <b>{point.y} ครั้ง</b>",
        colors: ["#4064AC", "#00B900", "#4064FF"],
        data: [
          {
            name: "Social",
            colorByPoint: true,
            data: [],
          },
        ],
      },
      boxplot: {
        title: {
          text: this.question.questionLabel,
        },
        subtitle: {
          text: "",
        },
        daterange: [],
        data: [],
      },
    };
  },
  mounted() {
    this.PieChart(this.social_selected, this.daterange);
    this.NumberInfo(this.social_selected, this.daterange);
    // this.BoxPlotChart(this.social_selected, this.daterange);
  },
  computed: {
    operationlist() {
      return this.$store.state.operation;
    },
  },
  methods: {
    NumberInfo(social, date) {
      this.$store
        .dispatch("DashboardGetNumberInfo", {
          questionID: this.question.questionID,
          social: social,
          daterange: date,
        })
        .then((response) => {
          this.numberinfo = response;
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardGetNumberPieChart)",
              title: "",
            });
          }
        });
    },
    PieChart(social, date) {
      this.$store
        .dispatch("DashboardGetNumberChart", {
          questionID: this.question.questionID,
          typechart: "piechart",
          social: social,
          daterange: date,
        })
        .then((response) => {
          // console.log(response);
          this.pie.data[0].data = [];
          response.map((d) => {
            let op = d.word.split(",")[0];
            // console.log(op)
            let operationtext = this.operationlist.find(
              (opr) => opr.operation === op
            );
            let opname = `${operationtext.text} ${
              op === "><" || op === "<>"
                ? `${d.word.split(",")[1]} และ ${d.word.split(",")[2]}`
                : d.word.split(",")[1]
            }`;
            this.pie.data[0].data.push({
              name: opname,
              y: d.value,
            });
          });
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardGetNumberPieChart)",
              title: "",
            });
          }
        });
    },
    BoxPlotChart(social, date) {
      this.$store
        .dispatch("DashboardGetNumberChart", {
          questionID: this.question.questionID,
          typechart: "boxplot",
          social: social,
          daterange: date,
        })
        .then((response) => {
          this.boxplot.data = response.data;
          this.boxplot.daterange = response.daterange;
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardGetNumberBoxPlotChart)",
              title: "",
            });
          }
        });
    },
    ChartChange(chart) {
      switch (chart.value) {
        case "boxplot":
          {
            this.chart_selected = "boxplot";
          }

          break;
        case "pie":
          {
            this.chart_selected = "pie";
          }

          break;
        case "column":
          {
            this.chart_selected = "column";
          }

          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
